import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { NationalitiesPage } from '@/features/nationalities/nationalities-page';

export const Route = createFileRoute('/_app/settings/nationalities')({
  component: () => (
    <RequireService service="NATIONALITY_LIST">
      <NationalitiesPage />
    </RequireService>
  ),
});
